module.exports = __webpack_public_path__ + "static/media/devops-info.228ec48c.png";